import {
    Badge,
    Box,
    Button,
    CopyButton,
    JsonInput,
    NumberFormatter,
    Text,
    Tooltip,
    rem,
} from '@mantine/core';
import { IconCopy, IconCopyCheck } from '@tabler/icons-react';

const CostCell = ({ cell, accessorKey }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Text>
            <NumberFormatter
                decimalScale={2}
                fixedDecimalScale={2}
                prefix={'$'}
                value={rowData[accessorKey] || 0}
            />
        </Text>
    );
};

const CostColumn = ({ header, accessorKey, columnProps = {} }) => ({
    accessorKey: accessorKey,
    header: header,
    //size: 2,
    minSize: 40,
    ...columnProps,
    Cell: ({ cell }) => (
        <CostCell
            cell={cell}
            accessorKey={accessorKey}
        />
    ),
    Footer: (info) => {
        const ignoreCount = ['TopUp'];

        // e.g. sum of ages
        const total = info.table.getRowModel().rows.reduce((acc, row) => {
            try {
                if (ignoreCount.includes(row.getValue('type'))) return acc + 0;
                return acc + Number(row.getValue(accessorKey));
            } catch {
                return 0;
            }
        }, 0);
        return (
            <Text>
                <NumberFormatter
                    decimalScale={2}
                    fixedDecimalScale={2}
                    prefix={'$'}
                    value={total || 0}
                />
            </Text>
        );
    },
});
export default CostColumn;
